import { Component,OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as Aos from 'aos';
@Component({
  selector: 'app-bulk-whats-app',
  templateUrl: './bulk-whats-app.component.html',
  styleUrls: ['./bulk-whats-app.component.scss']
})
export class BulkWhatsAppComponent implements OnInit {
  
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('WhatsApp Sender');

    setTimeout(() => {
      Aos.init();
    }, 500);       
      Aos.refresh();
  }
}
